// @flow
import { Observable } from 'rxjs';
import { catchError, startWith } from 'rxjs/operators';

export default <+T>(mapper: (any) => T): ((Observable<T>) => Observable<T>) =>
  catchError((e, t$) => t$.pipe(startWith(mapper(e))));
